<template class="content-info-event">
  <v-row no-gutters style="width: 100%">
    <v-col cols="8" v-if="eventInfo.eventType === 'MANEUVER'"
      ><ScreeningCatalogueAnalysisEventsManeuverVisualizer
        :maneuverInfoEvent="eventInfo"
        :idMission="idMission"
        v-on:cesium-visualizer-method="updateCesiumDatas"
      />
    </v-col>
    <v-col cols="8" v-if="eventInfo.eventType === 'CLOSE_APPROACH'">
      <ScreeningCatalogueAnalysisEventsConjunctionVisualizer
        :conjunctionInfoEvent="eventInfo"
        v-on:cesium-visualizer-method="updateCesiumDatas"
      />
    </v-col>
    <v-col cols="8" v-if="eventInfo.eventType === 'ORBIT_INSERTION'">
      <ScreeningCatalogueAnalysisEventsOrbitInsertionVisualizer
        :orbitInsertionInfoEvent="eventInfo"
        v-on:cesium-visualizer-method="updateCesiumDatas"
    /></v-col>
    <v-col v-if="isCesiumDataAvailable" cols="4"
      ><ScreeningCatalogueAnalysisEventsCesiumVisualizer
        style="margin-top: 20px"
        :satellitesDatas="getSatellitesDatas"
        :timelineDates="getTimelineDates"
        :description="getTextDescription"
    /></v-col>
    <v-col v-else cols="4"
      ><div
        class="d-flex align-center justify-center lighten-3"
        style="height: 500px; width: 100%; text-align: center"
      >
        The 3D visualization is not available for this event.
      </div></v-col
    >
  </v-row>
</template>
<script>
import ScreeningCatalogueAnalysisEventsCesiumVisualizer from './ScreeningCatalogueAnalysisEventsCesiumVisualizer.vue'
import ScreeningCatalogueAnalysisEventsOrbitInsertionVisualizer from './ScreeningCatalogueAnalysisEventsOrbitInsertionVisualizer.vue'
import ScreeningCatalogueAnalysisEventsConjunctionVisualizer from './ScreeningCatalogueAnalysisEventsConjunctionVisualizer.vue'
import ScreeningCatalogueAnalysisEventsManeuverVisualizer from './ScreeningCatalogueAnalysisEventsManeuverVisualizer.vue'

export default {
  name: 'ScreeningCatalogueAnalysisEventsCard',
  mixins: [],
  components: {
    ScreeningCatalogueAnalysisEventsOrbitInsertionVisualizer,
    ScreeningCatalogueAnalysisEventsConjunctionVisualizer,
    ScreeningCatalogueAnalysisEventsManeuverVisualizer,
    ScreeningCatalogueAnalysisEventsCesiumVisualizer
  },
  props: {
    eventInfo: {
      type: Object
    },
    idMission: {
      type: String
    }
  },
  data() {
    return {
      satellitesDatas: null,
      timelineDates: null,
      textDescription: null
    }
  },
  computed: {
    getSatellitesDatas() {
      return this.satellitesDatas
    },
    getTimelineDates() {
      return this.timelineDates
    },
    getTextDescription() {
      return this.textDescription
    },
    getEventInfo() {
      return this.eventInfo
    },
    isCesiumDataAvailable() {
      return (
        this.satellitesDatas != null &&
        this.satellitesDatas.length != 0 &&
        this.timelineDates != null &&
        this.textDescription != null
      )
    }
  },
  mounted() {},
  methods: {
    updateCesiumDatas(eventDatas) {
      this.satellitesDatas = eventDatas.satellitesDatas
      this.timelineDates = eventDatas.timelineDates
      this.textDescription = eventDatas.textDescription
    }
  }
}
</script>
<style></style>
